import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Box,
  Button,
  Th,
  Thead,
  Tr,
  Input,
  Spacer,
  Select,
  TableContainer,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// Table Components
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";

// Data
import { tablesProjectData, tablesTableData } from "variables/general";

// Icons
import { AiFillCheckCircle } from "react-icons/ai";
import { getUsersVerificationApplications } from "service/kyc.service";
import { useHistory } from "react-router-dom";
import { VERIFICATION_STATUS } from "../../constants";
import { exportAllKYCExcel } from "service/kyc.service";
import { useAppToast } from "utils/toastUtil";

function KYC() {
  const history = useHistory();
  const [useKycList, setKycList] = useState([]);
  const [searchKYC, setSearchKYC] = useState("");
  const [isExporting, setIsExporting] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState("");
  const { showToast } = useAppToast();

  const getKycList = async () => {
    const updateKycList = await getUsersVerificationApplications(
      searchKYC,
      verificationStatus
    );
    setKycList([...updateKycList]);
  };

  const exportAllKYC = async () => {
    setIsExporting(true);

    const res = await exportAllKYCExcel();

    if (res)
      showToast({
        title: "Success!",
        description: "Downloading excel",
        status: "success",
      });

    downloadExcel(res);
  };

  const downloadExcel = async (excel) => {
    // file object
    const file = new Blob([excel], {
      type: "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // anchor link
    const element = document.createElement("a");
    element.href = URL.createObjectURL(file);
    element.download = "KYC-" + Date.now() + ".csv";

    // simulate link click
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();

    setIsExporting(false);
  };

  useEffect(() => {
    getKycList();
  }, [searchKYC, verificationStatus]);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      {/* KYC Table */}
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <Spacer />
        <CardHeader p="6px 0px 22px 0px">
          {/* <Text fontSize="lg" color="#fff" fontWeight="bold">
            Authors Table
          </Text> */}
          <Box p={"2"} w={"full"}>
            <Input
              placeholder={"Search. . ."}
              onChange={(e) => {
                setSearchKYC(e.target.value);
              }}
              textColor={"black"}
              bg={"white"}
            />
          </Box>
          <Button
            variant="brand"
            fontSize={"xs"}
            mx={"2"}
            my={"2"}
            textTransform={"uppercase"}
            fontWeight={"extrabold"}
            backgroundColor={"green.500"}
            isLoading={isExporting}
            onClick={() => {
              exportAllKYC();
            }}
          >
            Export All
          </Button>
        </CardHeader>
        <CardBody>
          <TableContainer
            overscroll={"auto"}
            maxH={"2xl"}
            overflowY="scroll"
            position="relative"
            w={"full"}
          >
            <Table variant="simple" color="#fff" >
              <Thead
                position="sticky"
                top="0"
                zIndex="sticky"
                bg="gray.900"
                color="whiteAlpha.900"
              >
                <Tr my=".8rem" ps="0px" color="gray.400">
                  <Th
                    ps="0px"
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    NAME
                  </Th>
                  <Th
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    USERNAME
                  </Th>
                  <Th
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    ID
                  </Th>
                  <Th
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    <Select
                      placeholder="STATUS"
                      fontSize={"xs"}
                      fontWeight={"bold"}
                      textTransform={"uppercase"}
                      onChange={(e) => {
                        setVerificationStatus(e.target.value);
                      }}
                    >
                      {Object.keys(VERIFICATION_STATUS).map((key) => (
                        <option key={key} value={key}>
                          {key}
                        </option>
                      ))}
                    </Select>
                  </Th>
                  <Th
                    color="gray.400"
                    fontFamily="Plus Jakarta Display"
                    borderBottomColor="#56577A"
                  >
                    Date Verified
                  </Th>
                  <Th borderBottomColor="#56577A"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {useKycList.map((user, index, arr) => {
                  const kycUser = user.know_your_client;
                  return (
                    <TablesTableRow
                      key={index}
                      name={kycUser.id_name}
                      logo={kycUser?.files[0]?.file_url ?? null}
                      email={kycUser.email}
                      numberID={kycUser.id_number}
                      // domain={kycUser.domain}
                      status={kycUser.verification_status}
                      verifiedDate={kycUser.updated_at}
                      username={user.username}
                      click={() => {
                        console.log(user);
                        history.push({
                          pathname: "/admin/kyc/detail",
                          state: user,
                        });
                      }}
                    />
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default KYC;
